import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  language: string;
  titleTotal: string;
  readonly DELIMITER = '/';
  
  constructor(
    private translate: TranslateService) {
    this.language = 'en';
    this.titleTotal = '';
  }

  setLanguage(changeLanguage: string){
    this.language = 'en';
    if( changeLanguage == 'IN' ) {
      changeLanguage = 'en';
    } 
    if( changeLanguage == 'ES' ) {
      changeLanguage = 'es';
    } 
    if( changeLanguage == 'PT' ) {
      changeLanguage = 'pt';
    } 
    this.language = changeLanguage;
    localStorage.setItem('language', changeLanguage);
    this.usingLanguage();
  }

  getLanguage(){
    this.language = localStorage.getItem('language')!;
  }

  usingLanguage(){
    this.getLanguage();
    this.translate.use( this.language.toString() );
  }

  obtTexto(key: string){
    return this.translate.instant(key);
  }

  getDatatableLanguage() { 
    const result = { 
      'search': this.obtTexto('general.search'),
      'lengthMenu': this.obtTexto('general.lengthMenu'),
      'paginate': {
        'first':      this.obtTexto('general.first'),
        'previous':   this.obtTexto('general.previous'),
        'next':       this.obtTexto('general.next'),
        'last':       this.obtTexto('general.last'),
      }
    }; 
    return result; 
  }

  format(str: any | null): string | null {
    if( str != null ) {
      if( str != '' ) {
        var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join(this.DELIMITER);
      } else {
        return null;
      }
    } else {
      return null;
    }
	}

  padLeft = (number: number, length: number, character: string = '0'): string => {
		let result = String(number);
		for (let i = result.length; i < length; ++i) {
		result = character + result;
		}
		return result;
	};

}
